// Delivery screens are enabled by default; set false before building to hide them.
export const DELIVERY_ENABLED = process.env.REACT_APP_ENABLE_DELIVERY !== "false";

const DELIVERY_VIEWS = new Set([
  "billing", "billingReport", "billingSummary", "expenseDelivery", "miscExpenses",
]);

export function isViewEnabled(view) {
  if (["deliveryBoys", "salesMarket", "marketReports", "inwardMarket", "expenseMarket"].includes(view)) return false;
  return DELIVERY_ENABLED || !DELIVERY_VIEWS.has(view);
}
